const styleElement = document.createElement('style');

styleElement.innerText = '.grecaptcha-badge { visibility: hidden !important; }';

document.body.appendChild(styleElement);
